'use client';

import { createContext, useContext } from 'react';

/**
 * The identity the app renders for: the session's user, or while the session
 * loads, the request token's subject. `ConvexClientProvider` remounts the app
 * when it changes (an account switch in another tab, say).
 */
export const RenderIdentityContext = createContext<string | null>(null);

/**
 * Whether data the server read for `identity` may render. Server-rendered
 * snapshots and seeds outlive an account change in the router's retained
 * layouts; the next identity must never see the previous one's data.
 */
export function useIsRenderIdentity(identity: string | null): boolean {
  const current = useContext(RenderIdentityContext);
  return identity !== null && identity === current;
}
